import React, { useEffect } from 'react';
import './BlueberryDMC.css';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Heading from '../../../utls/Heading';


const BlueberryDMC = () => {
  useEffect(() => {
    // Initialize Bootstrap tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <>
      <div className="container bb-dmc position-relative">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex justify-content-center align-items-center flex-column">
              <Heading className="customheadings text-center mb-0">
                <span>Blueberry Travel </span>Expands to Your Favourite Destinations!
              </Heading>
              <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/New%20Map%20for%20Global%20Solutions.png" alt="" className='d-block d-md-none w-100' loading="lazy" />
              <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/New%20Map%20for%20Global%20Solutions.png" alt="" className="img-fluid BlueberryDMCMap d-none d-md-block"  loading="lazy" />
              {/* Tooltip Button */}
              <button
                type="button"
                className=" btn-secondary border-0 position-absolute uae-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Djibouti"
                
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute india-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="India"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute mada-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Madagascar"
              >
              </button>
              <button
                type="button"
                className="btn border-0 position-absolute co-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Co te D'Ivoire"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute malavi-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Malawi"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute kenya-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Kenya"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute uganda-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Uganda"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute tanzania-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Tanzania"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute mozambique-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Mozambique"
              >
              </button>
              <button
                type="button"
                className="btn border-0 position-absolute south-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="South Africa"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute namibia-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Namibia"
              >
              </button>
              <button
                type="button"
                className="btn border-0 position-absolute botswana-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Botswana"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute zimbabwe-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Zimbabwe"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute zambia-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Zambia"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute angola-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Angola"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute drc-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="DRC"
              >
              </button>

              
              <button
                type="button"
                className="btn border-0 position-absolute congo-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Congo"
              >
              </button>
              

              <button
                type="button"
                className="btn border-0 position-absolute car-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="CAR"
              >
              </button>
              <button
                type="button"
                className="btn border-0 position-absolute cameroon-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Cameroon"
              >
              </button>
              <button
                type="button"
                className="btn border-0 position-absolute gabon-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Gabon"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute nigeria-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Nigeria"
              >
              </button>

              <button
                type="button"
                className="btn border-0 position-absolute togo-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Togo"
              >
              </button>
              <button
                type="button"
                className="btn border-0 position-absolute ghana-btn mt-3"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                title="Ghana"
              >
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlueberryDMC;
